export default __webpack_public_path__ + "663ae6ea5cbe0ed8ac11a443536095c6.png";